import React from 'react'
import { Routes, Route } from 'react-router-dom'

import IndexPage from '../src/pages/home'
import LoginPage from '../src/pages/user/LoginPage'
import DeveloperCenter from '../src/pages/developerCenter'
import AppDetailsPage from './pages/developerCenter/myApp/appDetails'
import CheckNewVerisonPage from './pages/developerCenter/myApp/checkNewVersion'
const App = () => {

    const userInfo = JSON.parse(localStorage.getItem("authenticated"));

    return (
        <Routes>
            {/* 默认初始化入口/home*/}
            {/* <Route path="/" element={<Navigate to="/" />} /> */}
            {/* home模块路由 */}
            <Route path="/*" element={<IndexPage />} />
            <Route path="/sign" element={<LoginPage />} />
            {/* admin模块路由 */}
            <Route path="/developerCenter/*" element={<DeveloperCenter />} />
            {/* app详情下载/检查最新 */}
            <Route path="/developerCenter/apk/appDetails" element={< AppDetailsPage />} />
            <Route path="/developerCenter/apk/checkNewVersion" element={< CheckNewVerisonPage />} />

        </Routes>
    );

}

export default App;